angular.module('impactx.themeworld').controller('ThemeWorldActivationController', [
    'ThemeWorldService',
    '$routeParams',
    ThemeWorldActivationController
]);

function ThemeWorldActivationController(ThemeWorldService, $routeParams) {
    ThemeWorldService.activateThemeWorldSearch($routeParams.id);
}